import { css  } from '@emotion/core'
import { mq } from '../../cssInJs'

// export default {
//   top: css(mq({
//     //height: [44, null, 80],
//     height: [44, null, 56],
//     background: 'black',
//     position: 'fixed',
//     width: '100%',
//     zIndex: '999',
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     transition: 'all 0.3s'
//   })),
//   // topScrolled: css(mq({
//   //   height: [44, null, 56],
//   // })),
//   logo: css(mq({
//   })),
//   logoImg: css(mq({
//     display: 'block',
//     height: [22, null, 36],
//   })),
//   logoScrolled: css(mq({

//   })),
// }

export default {
  top: css(mq({
    //height: [44, null, 80],
    height: [44, null, 80],
    background: '#e2e2e2',
    position: 'fixed',
    width: '100%',
    zIndex: '999',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'all 0.3s',
    padding: '5px 70px'
  })),
  topScrolled: css(mq({
    height: [44, null, 80],
  })),
  logo: css(mq({
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    transition: 'all 0.3s ease-in-out',
  })),
  logoImg: css(mq({
    display: 'block',
    height: [35, null, 50],
    maxHeight: '80%',
    transition: 'all 0.3s ease-in-out',
  })),
  logoImgScrolled: css(mq({
    height: [35, null, 70],
  })),
  logoScrolled: css(mq({
  })),
  topHeaderContainer: css(mq({
    maxWidth: '1240px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  })),
  topHeaderContainerRight: css(mq({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  })),
  top__navi__con__wrap: mq({
    background: "#002e5b",
    // padding: "5px 5px 2px",
    position: "relative",
    height: ["39px", null, "auto"],
  }),

  top__navi__item: mq({
    color: "white",
    fontSize: "0.8rem",
    position: "relative",
    svg: {
      paddingBottom: "3px",
      marginRight: "10px",
    },
    a: {
      color: "inherit",
      display: "inline-block",
      padding: "0.4rem 0.5rem 11px",
      // fontWeight: 600,
      fontSize: "0.65rem",
      "&:hover": {
        textDecoration: "none",
        backgroundColor: "yellow",
      },
    },
  }),

  mast__head__svg__warpp: mq({
    position: "relative",
    // "&:before": mq({
    //   content: "''",
    //   width: "50%",
    //   left: 0,
    //   top: 0,
    //   height: "74px",
    //   position: "absolute",
    //   backgroundColor: "white",
    //   display: ["none", null, "block"],
    //   zIndex: "-1",
    //   transition: "all 0.5s ease",
    //   transform: "rotate(1deg)",
    //   "@media (min-width: 2561px)": {
    //     //display: 'block',
    //     transform: "rotate(0deg)",
    //   },
    // }),
    "&:after": mq({
      content: "''",
      width: "50%",
      right: 0,
      top: 0,
      height: "75%",
      position: "absolute",
      backgroundColor: "white",
      display: ["none", null, "block"],
      zIndex: "-1",
      transition: "all 0.5s ease",
      transform: "rotate(-1deg)",
      "@media (min-width: 2561px)": {
        //display: 'block',
        transform: "rotate(0deg)",
      },
    }),
  })
}